import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { getAllAnnouncements } from "../../store/actions/announcement";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../../config";
import Search from "./Search";
import Cart from "./Cart";
import Navigation from "./Navigation";
import { Helmet } from "react-helmet";
import UserMenu from "./UserMenu";
import "./ModernHeader.css";

class ModernHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isScrolled: false,
      mobileMenuOpen: false,
      scrollY: 0,
      currentAnnouncementIndex: 0,
    };
    this.carouselRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);

    // Duyuruları yükle
    !this.props.announcement.announcements && this.props.getAllAnnouncements();
  }

  componentDidUpdate(prevProps) {
    // Duyurular yüklendiğinde carousel'i başlat
    if (
      !prevProps.announcement.announcements &&
      this.props.announcement.announcements
    ) {
      this.startAnnouncementCarousel();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);

    // Carousel interval'i temizle
    if (this.announcementInterval) {
      clearInterval(this.announcementInterval);
    }

    // Scroll frame'i temizle
    if (this.scrollFrameId) {
      cancelAnimationFrame(this.scrollFrameId);
    }

    // Body class'ını temizle
    document.body.classList.remove("header-fixed");
  }

  startAnnouncementCarousel = () => {
    // Sadece birden fazla duyuru varsa carousel'i başlat
    if (
      this.props.announcement.announcements &&
      this.props.announcement.announcements.length > 1
    ) {
      this.announcementInterval = setInterval(() => {
        this.setState((prevState) => ({
          currentAnnouncementIndex:
            (prevState.currentAnnouncementIndex + 1) %
            this.props.announcement.announcements.length,
        }));
      }, 4000);
    }
  };

  handleScroll = () => {
    // Use requestAnimationFrame for smoother performance
    if (this.scrollFrameId) {
      cancelAnimationFrame(this.scrollFrameId);
    }

    this.scrollFrameId = requestAnimationFrame(() => {
      const scrollY = window.scrollY;

      // Header'ın başlangıç pozisyonunu hesapla (announcement bar height + header'ın normal pozisyonu)
      const announcementElement = document.querySelector(
        ".modern-header-announcement",
      );
      const announcementHeight = announcementElement
        ? announcementElement.offsetHeight
        : 36;
      const threshold = announcementHeight + 10; // Announcement bar'ı geçtikten sonra fixed ol

      const shouldBeScrolled = scrollY > threshold;

      // Only update if state actually changes
      if (shouldBeScrolled !== this.state.isScrolled) {
        // Body class'ını güncelle (content jump'ını önlemek için)
        if (shouldBeScrolled) {
          document.body.classList.add("header-fixed");
        } else {
          document.body.classList.remove("header-fixed");
        }

        this.setState({
          isScrolled: shouldBeScrolled,
          scrollY: scrollY,
        });
      }
    });
  };

  handleResize = () => {
    if (window.innerWidth > 768 && this.state.mobileMenuOpen) {
      this.setState({ mobileMenuOpen: false });
    }
  };

  toggleMobileMenu = () => {
    const willOpen = !this.state.mobileMenuOpen;

    // Store current scroll position before hiding overflow
    if (willOpen) {
      this.savedScrollPosition = window.scrollY;
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.savedScrollPosition}px`;
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      // Restore scroll position
      if (this.savedScrollPosition !== undefined) {
        window.scrollTo(0, this.savedScrollPosition);
      }
    }

    this.setState({ mobileMenuOpen: willOpen });
  };

  closeMobileMenu = () => {
    // Reset body styles and restore scroll position
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";

    // Restore scroll position
    if (this.savedScrollPosition !== undefined) {
      window.scrollTo(0, this.savedScrollPosition);
    }

    this.setState({ mobileMenuOpen: false });
  };

  renderMetaHeader() {
    let title = this.props.setting.setting && this.props.setting.setting.title;
    let description =
      this.props.setting.setting && this.props.setting.setting.description;
    let keywords =
      this.props.setting.setting && this.props.setting.setting.keywords;
    let og_type = null;
    let og_title = null;
    let og_image = null;
    let og_url = null;

    const { pathname } = this.props.router.location;
    if (pathname === "/") {
    } else if (pathname.indexOf("/p/") >= 0) {
      const aar = pathname.split("/");
      const slugP = aar[aar.length - 1];
      const page = this.props.page.page.find(({ slug }) => slug === slugP);
      title = `${page.menu_title} - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/sifremi-unuttum") {
      title = `Şifremi Unuttum - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/reset-password") >= 0) {
      title = `Şifremi Sıfırla - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/giris-yap") {
      title = `Giriş Yap - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/uye-ol") {
      title = `Üye Ol - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim") {
      title = `Hesabım - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparislerim") {
      title = `Siparişlerim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparis-gecmisim") {
      title = `Sipariş Geçmişim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/siparis/detay") {
      title = `Sipariş Detayları - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/profilimi-duzenle") {
      title = `Profilimi Düzenle - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/adreslerim") {
      title = `Adreslerim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/hesabim/sifremi-guncelle") {
      title = `Şifremi Güncelle - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/kategori/") >= 0) {
      title = `${
        this.props.category.category && this.props.category.category.title
      } - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname.indexOf("/urun/") >= 0) {
      if (this.props.product.product) {
        title = `${this.props.product.product.name} - ${this.props.setting.setting.title}`;
        if (this.props.product.product.meta_description !== "") {
          description = this.props.product.product.meta_description;
        }
        if (this.props.product.product.meta_keywords !== "") {
          keywords = this.props.product.product.meta_keywords;
        }
        og_type = "article";
        og_title = this.props.product.product.title;
        og_image = PUBLIC_URL(this.props.product.product.image);
        og_url = window.location;
      }
    } else if (pathname === "/sepet") {
      title = `Sepetim - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/odeme/giris") {
      title = `Ödeme için giriş yapın - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/odeme" || pathname === "/odeme/misafir") {
      title = `Ödeme - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else if (pathname === "/siparis-basarili") {
      title = `Siparişiniz Başarıyla Alındı - ${this.props.setting.setting.title}`;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    } else {
      title = this.props.setting.setting.title;
      description = this.props.setting.setting.description;
      keywords = this.props.setting.setting.keywords;
    }

    const meta = [
      { name: "description", content: description },
      { name: "keywords", content: keywords },
    ];

    og_type && meta.push({ property: "og:type", content: og_type });
    og_title && meta.push({ property: "og:title", content: og_title });
    og_image && meta.push({ property: "og:image", content: og_image });
    og_url && meta.push({ property: "og:url", content: og_url });

    return <Helmet title={title} meta={meta} />;
  }

  render() {
    const { isScrolled, mobileMenuOpen } = this.state;

    return (
      <React.Fragment>
        {this.renderMetaHeader()}
        {/* Top Bar - Duyuru Barı */}
        {this.props.announcement.announcements &&
          this.props.announcement.announcements.length > 0 && (
            <div
              className="modern-header-announcement"
              style={{
                color:
                  this.props.setting.setting &&
                  this.props.setting.setting.annocoment.color,
                background:
                  (this.props.setting.setting &&
                    this.props.setting.setting.annocoment.bg) ||
                  "linear-gradient(135deg, #7fb401 0%, #91cc08 100%)",
              }}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="announcement-carousel">
                      {/* Sol Navigation */}
                      {this.props.announcement.announcements.length > 1 && (
                        <button
                          className="announcement-prev"
                          onClick={() => {
                            this.setState((prevState) => ({
                              currentAnnouncementIndex:
                                prevState.currentAnnouncementIndex === 0
                                  ? this.props.announcement.announcements
                                      .length - 1
                                  : prevState.currentAnnouncementIndex - 1,
                            }));
                          }}
                          aria-label="Önceki duyuru"
                        >
                          <FontAwesomeIcon icon={["fas", "circle"]} />
                        </button>
                      )}

                      {/* Orta Duyuru Metni */}
                      <div className="announcement-text">
                        <Link
                          to={
                            this.props.announcement.announcements[
                              this.state.currentAnnouncementIndex
                            ].link
                          }
                          className="announcement-link"
                        >
                          {
                            this.props.announcement.announcements[
                              this.state.currentAnnouncementIndex
                            ].title
                          }
                        </Link>
                      </div>

                      {/* Sağ Navigation */}
                      {this.props.announcement.announcements.length > 1 && (
                        <button
                          className="announcement-next"
                          onClick={() => {
                            this.setState((prevState) => ({
                              currentAnnouncementIndex:
                                (prevState.currentAnnouncementIndex + 1) %
                                this.props.announcement.announcements.length,
                            }));
                          }}
                          aria-label="Sonraki duyuru"
                        >
                          <FontAwesomeIcon icon={["fas", "circle"]} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        {/* Ana Header */}
        <header className={`modern-header ${isScrolled ? "scrolled" : ""}`}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="header-wrapper">
                  {/* Sol Bölüm - Logo ve Menü */}
                  <div className="header-left">
                    {/* Mobile Menü Butonu */}
                    <button
                      className="mobile-menu-toggle"
                      onClick={this.toggleMobileMenu}
                      aria-label="Menü"
                    >
                      <span
                        className={`hamburger ${
                          mobileMenuOpen ? "active" : ""
                        }`}
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                      </span>
                    </button>

                    {/* Logo */}
                    <Link to="/" className="logo-wrapper">
                      <img
                        src={PUBLIC_URL(
                          this.props.setting.setting &&
                            this.props.setting.setting.logo,
                        )}
                        alt={
                          this.props.setting.setting &&
                          this.props.setting.setting.title
                        }
                        className="logo"
                      />
                    </Link>
                  </div>

                  {/* Orta Bölüm - Arama */}
                  <div className="header-center">
                    {/* Desktop Search */}
                    <div className="search-wrapper desktop-only">
                      <Search />
                    </div>
                    {/* Mobile Search */}
                    <div className="search-wrapper mobile-only">
                      <Search />
                    </div>
                  </div>

                  {/* Sağ Bölüm - Kullanıcı İşlemleri ve Sepet */}
                  <div className="header-right">
                    {/* Telefon - Desktop */}
                    <div className="header-phone desktop-only">
                      <a
                        href={`tel:${
                          this.props.setting.setting &&
                          this.props.setting.setting.phone
                        }`}
                      >
                        <FontAwesomeIcon icon={["fas", "phone"]} />
                        <div className="phone-text">
                          <span className="label">Sipariş Hattı</span>
                          <span className="number">
                            {this.props.setting.setting &&
                              this.props.setting.setting.phone}
                          </span>
                        </div>
                      </a>
                    </div>

                    {/* Kullanıcı İşlemleri - Desktop Only */}
                    <div className="desktop-only user-actions">
                      {this.props.customer.customer ? (
                        // Giriş yapıldıysa: Sadece UserMenu dropdown
                        <UserMenu />
                      ) : (
                        // Giriş yapılmadıysa: Kullanıcı ikonu + Sipariş Sorgula
                        <React.Fragment>
                          <Link
                            to="/giris-yap"
                            className="user-login-btn"
                            title="Giriş Yap"
                          >
                            <FontAwesomeIcon icon={["fas", "user"]} />
                          </Link>
                          <Link
                            to="/siparis-sorgula"
                            className="order-inquiry-btn"
                            title="Sipariş Sorgula"
                          >
                            <FontAwesomeIcon icon={["fas", "search"]} />
                            <span>Sipariş Sorgula</span>
                          </Link>
                        </React.Fragment>
                      )}
                    </div>

                    {/* Sosyal Medya - Desktop */}
                    <div className="social-media desktop-only">
                      {this.props.setting.setting &&
                        this.props.setting.setting.facebook && (
                          <a
                            href={this.props.setting.setting.facebook}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link facebook"
                            aria-label="Facebook"
                          >
                            <FontAwesomeIcon icon={["fab", "facebook"]} />
                          </a>
                        )}
                      {this.props.setting.setting &&
                        this.props.setting.setting.instagram && (
                          <a
                            href={this.props.setting.setting.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-link instagram"
                            aria-label="Instagram"
                          >
                            <FontAwesomeIcon icon={["fab", "instagram"]} />
                          </a>
                        )}
                    </div>

                    {/* Sepet */}
                    <div
                      className="cart-wrapper"
                      style={{ position: "relative", zIndex: 200 }}
                    >
                      <Cart />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation - Desktop */}
          <div
            className="navigation-wrapper desktop-only"
            style={{ zIndex: 100 }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <Navigation />
                </div>
              </div>
            </div>
          </div>
        </header>
        {/* Mobile Menü Overlay */}
        <div
          className={`mobile-menu-overlay ${mobileMenuOpen ? "active" : ""}`}
          onClick={this.closeMobileMenu}
        ></div>

        {/* Mobile Menü */}
        <div className={`mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
          <div className="mobile-menu-header">
            <Link to="/" className="mobile-logo" onClick={this.closeMobileMenu}>
              <img
                src={PUBLIC_URL(
                  this.props.setting.setting && this.props.setting.setting.logo,
                )}
                alt={
                  this.props.setting.setting && this.props.setting.setting.title
                }
              />
            </Link>
            <button
              className="mobile-menu-close"
              onClick={this.closeMobileMenu}
            >
              <FontAwesomeIcon icon={["fas", "times"]} />
            </button>
          </div>

          {/* Modern Mobile User Card */}
          {this.props.customer.customer && (
            <div className="modern-user-card">
              <div className="user-card-content">
                <div className="user-avatar">
                  <div className="avatar-circle">
                    <FontAwesomeIcon icon={["fas", "user"]} />
                  </div>
                  {this.props.customer.customer.discount_enabled && (
                    <div className="premium-crown">
                      <FontAwesomeIcon icon={["fas", "crown"]} />
                    </div>
                  )}
                </div>
                <div className="user-info">
                  <div className="welcome-text">Hoş geldiniz</div>
                  <div className="user-name">
                    {this.props.customer.customer.full_name}
                  </div>
                  {this.props.customer.customer.discount_enabled && (
                    <div className="premium-status">
                      <span className="premium-dot"></span>
                      <span>Premium Üye</span>
                    </div>
                  )}
                </div>
              </div>
              <div className="user-card-decoration"></div>
            </div>
          )}
          {/* Mobile Navigation */}
          <div className="mobile-menu-nav">
            <Navigation
              onItemClick={this.closeMobileMenu}
              isMobileMenu={true}
            />
          </div>
          {/* Mobile Menu Links */}
          <div className="mobile-menu-links">
            {this.props.customer.customer ? (
              <React.Fragment>
                <Link to="/hesabim" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "user"]} />
                  Hesabım
                </Link>
                <Link to="/hesabim/siparislerim" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "box"]} />
                  Siparişlerim
                </Link>
                <Link to="/hesabim/adreslerim" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "map-marker-alt"]} />
                  Adreslerim
                </Link>
                <Link to="/siparis-sorgula" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "search"]} />
                  Sipariş Sorgula
                </Link>
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.logOut();
                    this.closeMobileMenu();
                  }}
                  style={{
                    border: "none",
                    background: "none",
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    padding: "12px 20px",
                    color: "#333",
                  }}
                >
                  <FontAwesomeIcon icon={["fas", "power-off"]} />
                  Çıkış Yap
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Link to="/giris-yap" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "sign-in-alt"]} />
                  Giriş Yap
                </Link>
                <Link to="/uye-ol" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "user-plus"]} />
                  Üye Ol
                </Link>
                <Link to="/siparis-sorgula" onClick={this.closeMobileMenu}>
                  <FontAwesomeIcon icon={["fas", "search"]} />
                  Sipariş Sorgula
                </Link>
              </React.Fragment>
            )}
          </div>
          {/* Mobile Contact */}
          <div className="mobile-menu-contact">
            <a
              href={`tel:${
                this.props.setting.setting && this.props.setting.setting.phone
              }`}
            >
              <FontAwesomeIcon icon={["fas", "phone"]} />
              <span>
                Sipariş Hattı:{" "}
                {this.props.setting.setting && this.props.setting.setting.phone}
              </span>
            </a>
          </div>
          {/* Mobile Social */}
          <div className="mobile-menu-social">
            {this.props.setting.setting &&
              this.props.setting.setting.facebook && (
                <a
                  href={this.props.setting.setting.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={["fab", "facebook"]} />
                </a>
              )}
            {this.props.setting.setting &&
              this.props.setting.setting.instagram && (
                <a
                  href={this.props.setting.setting.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={["fab", "instagram"]} />
                </a>
              )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  router,
  customer,
  setting,
  page,
  category,
  product,
  announcement,
}) => {
  return {
    router,
    customer,
    setting,
    page,
    category,
    product,
    announcement,
  };
};

const mapDispatchToProps = { logOut, getAllAnnouncements };

export default connect(mapStateToProps, mapDispatchToProps)(ModernHeader);



// WEBPACK FOOTER //
// ./src/components/shared/ModernHeader.js